import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch5 } from "../commonApis/commonApis";
import { ApiResponse } from "./loginApis";
const url = process.env.REACT_APP_BASE_URL;

type NotificationStatus = {
    seen: boolean;
}

export const useFetchNotificationsData = (
    page: number = 1,
    limitOrSearch?: number | string,
    search?: string
) => {
    let limit = 20;
    let searchFor = "";

    if (typeof limitOrSearch === "number") {
        limit = limitOrSearch;
        searchFor = search || "";
    } else if (typeof limitOrSearch === "string") {
        searchFor = limitOrSearch;
    }

    return useQuery({
        queryKey: ["NotificationsData", page, limit, searchFor],
        queryFn: async () => {
            const res = await fetch3(
                `${url}/api/lm-notifications?page=${page}&limit=${limit}&searchFor=${encodeURIComponent(searchFor)}&type=lmClient`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }

            return res.data; // 👈 This returns your full user object
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useNotificationStatusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: NotificationStatus) => {
            const res: ApiResponse = await fetch5(
                `${url}/api/lm-notifications/${id}?type=lmClient`,
                "PATCH",
                payload
            );

            // Manually throw error if success is false
            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
        },
        onSuccess: (data: any) => {
            console.log("✅ Notification status updated successfully:", data);
            return;
        },
        onError: (error: any) => {
            console.error("❌ Notification status update request failed:", error.message);
        },
    });
};

export const useFetchNotificationBulkJobDetailsData = (
    bulkJobId?: string,
    page: number = 1,
    limit: number = 100
) => {
    return useQuery({
        queryKey: ["bulkJobNotificationDetails", bulkJobId, page, limit],
        queryFn: async () => {
            if (!bulkJobId) return null;
            const res = await fetch3(
                `${url}/api/bulk/jobs/${bulkJobId}?page=${page}&limit=${limit}&type=LM`,
                "get"
            );

            if (!res || !res.data) return res.message;
            return res.data;
        },
        enabled: !!bulkJobId,
        staleTime: 1000 * 60 * 5,
    });
};

export const markNotificationAsSeen = async (id: string | number, queryClient?: any) => {
    try {
        await fetch5(`${url}/api/lm-notifications/${id}?type=lmClient`, "PATCH", { seen: true });
        if (queryClient) {
            queryClient.invalidateQueries({ queryKey: ["NotificationsData"] });
        }
    } catch (e) {
        console.error("Failed to mark notification as seen:", e);
    }
};
